import React from 'react';

export default function Services() {
  return (
    <main>
      {/* services.html had no unique body content yet —
          you can populate this with your own services details */}
      <h1 className="text-3xl font-bold text-center my-12">Our Services</h1>
      <p className="text-center text-gray-600">
        (Populate this page with your detailed service offerings…)
      </p>
    </main>
  );
}
